import { render, staticRenderFns } from "./square.vue?vue&type=template&id=b7448fa2&scoped=true&"
import script from "./square.vue?vue&type=script&lang=js&"
export * from "./square.vue?vue&type=script&lang=js&"
import style0 from "./square.vue?vue&type=style&index=0&id=b7448fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7448fa2",
  null
  
)

export default component.exports